import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

const Filter = ({ onFilter, onClear, extraFiltersState, setExtraFiltersState }) => {

  const handleInputChange = (field, value) => {
      setExtraFiltersState(prev => ({
          ...prev,
          values: {
              ...prev.values,
              [field]: value 
          }
      }));
  }

  const handleClear = () => {
    onClear();
  };

  return (
    <div className="filters-flex">
      <Form>
        <Row className="align-items-end g-3">
          <Col md={2} sm={6}>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Start Date</Form.Label>
              <Form.Control
                type="date"
                value={extraFiltersState.values.start_date || ''}
                onChange={(e) => handleInputChange('start_date', e.target.value)}
                className="input-field w-100"
              />
            </Form.Group>
          </Col>
          <Col md={2} sm={6}>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">End Date</Form.Label>
              <Form.Control
                type="date"
                value={extraFiltersState.values.end_date || ''}
                onChange={(e) => handleInputChange('end_date', e.target.value)}
                className="input-field w-100"
              />
            </Form.Group>
          </Col>
          <Col md={2} sm={6}>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Integration Type</Form.Label>
              <Form.Select
                value={extraFiltersState.values.integration_type || ''}
                onChange={(e) => handleInputChange('integration_type', e.target.value)}
                className="input-field w-100"
              >
                  <option value="">Select Type</option>
                  <option value="aws">AWS</option>
                  <option value="zoom">Zoom</option>
              </Form.Select>
            </Form.Group>
          </Col>
           <Col md={2} sm={6}>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Status</Form.Label>
               <Form.Select
                value={extraFiltersState.values.status || ''}
                onChange={(e) => handleInputChange('status', e.target.value)}
                className="input-field w-100"
              >
                  <option value="">Select Status</option>
                  <option value="Processing">Processing</option>
                  <option value="Completed">Completed</option>
                  <option value="Failed">Failed</option>
              </Form.Select>
            </Form.Group>
          </Col>
           <Col md={2} sm={6}>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Integration ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="UUID"
                value={extraFiltersState.values.integration_id || ''}
                onChange={(e) => handleInputChange('integration_id', e.target.value)}
                className="input-field w-100"
              />
            </Form.Group>
          </Col>
          
          <Col md={2} sm={12} className="mb-3 d-flex gap-2">
             <Button variant="primary" onClick={onFilter} className="w-100">
              Apply
            </Button>
            <Button variant="secondary" onClick={handleClear} className="w-100">
              Clear
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Filter;
